import type { ReactNode } from "react";
import { cn } from "@/utils/cn";

export interface TabItem {
  value: string;
  label: string;
  count?: number;
}

export function Tabs({
  items,
  value,
  onChange,
  className,
}: {
  items: TabItem[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  return (
    <div className={cn("inline-flex gap-1 rounded-lg border border-border bg-cream-50 p-1", className)}>
      {items.map((item) => (
        <button
          key={item.value}
          onClick={() => onChange(item.value)}
          className={cn(
            "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
            value === item.value
              ? "bg-teal-500 text-cream-50"
              : "text-ink-muted hover:bg-cream-200",
          )}
        >
          {item.label}
          {item.count !== undefined && (
            <span className="ml-1.5 opacity-80">({item.count})</span>
          )}
        </button>
      ))}
    </div>
  );
}

export function TabPanel({ active, children }: { active: boolean; children: ReactNode }) {
  if (!active) return null;
  return <>{children}</>;
}
